// extracted by mini-css-extract-plugin
export default {"cards-list":"_5D2NQT6J"};